export default "__VITE_ASSET__35926000__"